let timer;

const handleUrl = (apiUrl) => {
  let parsedUrl = JSON.parse(localStorage.getItem("apiUrl"));
  let getUrl = parsedUrl?.find((data) => data.url_description === apiUrl);
  return getUrl.url;
};
const helpers = {
  getUrl() {
    console.log(window.config, "windowConfig");
    return `${window.config.baseUrl}/be/`;
    //return "http://103.253.15.184:8109/"; //skinsoul train/migrate
    // return "http://103.253.15.184:8115/";
    //return "http://103.253.15.229:8126/be/"; //magicionv2 in 229
    //hstcmtrain on healspatrain db
    //return "http://103.253.14.219:8100/be/"; //mydemotrain
    //return "http://103.253.15.184:8003/"; //ashiq
    //return "http://103.253.14.235:8403/be/"; //emmabelletest
    //return "http://103.253.15.184:8001/be/"; //sitedebug
    //return "http://103.253.15.184:8101/be/"; //glamourtrain
    //return "http://103.253.14.235:8100/be/"; //stagingtrain
    //return "http://103.253.14.235:8408/be/"; //kireitrain
    //return "http://103.253.14.219:3101/be/"; //coulisseheirtrain
    // return "http://103.253.14.235:8419/be/"; //salononetrain
    //return "http://103.253.14.235:8409/be/"; //ottrain
    //return "http://103.253.14.235:8406/be/"; //esthetictrain
    //return "http://103.253.14.235:8402/be/"; //essentials_train
    //return "http://103.253.14.219:8107/be/"; //johairtrain
    //return "http://103.253.15.229:8102/be/"; //skinsoultest
    //return "http://103.253.14.219:3107/be/"; //sincereskintrain
    //return "http://103.253.14.219:8101/be/"; //eternalbeautiquetrain
    //return "http://103.253.14.219:8110/be/"; //impressiontrain elenalovetrain
    //return "http://103.253.14.219:3116/be/"; //nailqueentrain
    //return "http://103.253.14.219:8119/be/"; //xinhuatcmtrain
    //return "http://103.253.14.219:8118/be/"; //citibellatrain
    //return "http://103.253.14.219:8116/be/"; //sumiskintrain
    //return "http://103.253.14.219:8102/be/"; //avantetrain
    //return "http://103.253.15.184:8006/"; //elvatrain
    //return "http://103.253.15.184:8120/"; //twoherbstrain
    //return "http://103.253.15.184:8102/be/"; //navistrain
    //return "http://103.253.15.184:8100/be/"; //mumandbabiestrain
    //return "http://103.253.15.184:8104/be/"; //synthesistrain
    //return "http://103.253.15.184:8113/"; //embracetrain
    //return "http://103.253.15.184:8112/"; //avantetrain
    //return "http://103.253.15.184:8008/"; //destresstrain
    //return "http://103.253.15.184:8002/"; //skinhugtrain monicatestwithhealspa
    //return "http://103.253.15.184:8103/"; //pureskinmigrate
    //return "http://103.253.15.184:8106/"; //pixietrain
    //return "http://103.253.15.184:8110/"; //tnctrain
    //return "http://103.253.15.184:8100/"; //mmpptrain
    //return "http://103.253.15.184:8005/"; //magiciontrain
    //return "http://103.253.15.218:8001/";
    // return "http://103.253.15.184:8000/be/";
    //return "http://103.253.15.184:8104/"; //pureskintrain
    //return "http://103.253.15.184:8010/"; //ksparlour
    //return "http://103.253.15.184:8107/"; //IMDA
    //return "http://103.253.15.184:8006/"; //ksparlourtrain
    //return "http://103.253.15.184:8003/"; //citibellatrain
    //return "http://103.253.15.184:8000/"; //doodle Monica
    //return "http://103.253.15.184:8009/"; //energytrain
    //return "http://103.253.15.184:8105/"; //energytcmtrain
    //return "http://103.253.15.184:8102/"; //quantum
    //return "http://103.253.15.184:8105/"; //tnctrain
    //return "http://103.253.15.229:8101/";
    //return "https://stresstest.beautecloud.com/be/";
    //return "https://studioa.beautecloud.com/be/";
    //return "https://aplusbeauty.beautecloud.com/be/";
    //return "https://oceanleaf.beautecloud.com/be/";
    //return "https://salonone.beautecloud.com/be/";
    // return "https://beautesoft.nature360global.com/be/"; //staging
    //return "https://tnctrain.beautecloud.com/be/";
    //return "https://lnd.beautecloud.com/be/";
    //return "https://risespa.beautecloud.com/be/";
    //return "https://beautyforever.beautecloud.com/be/";
    //return "https://luxelle.beautecloud.com/be/";
    //return "https://beautytouch.beautecloud.com/be/";
    //return "https://beautypalace.beautecloud.com/be/";
    //return "https://vainessentials.beautecloud.com/be/";
    //return "https://f21.beautecloud.com/be/";
    //return "https://train.beautecloud.com/be/"; //impressiontrain
    //return "https://ot.beautecloud.com/be/";
    //return "https://essentials.beautecloud.com/be/";
    //return "https://sincereskin.beautecloud.com/be/";
    //return "https://johair.beautecloud.com/be/";
    //return "https://kirei.beautecloud.com/be/";
    //return "https://slbeauty.beautecloud.com/be/";
    //return "https://staging.beautecloud.com/be/";
    //return "https://nailqueen.beautecloud.com/be/";
    //return "https://eternalbeautique.beautecloud.com/be/";
    //return "https://lovebeauty.beautecloud.com/be/";
    //return "https://bestbeauty.beautecloud.com/be/";
    //return "https://xinhuatcm.beautecloud.com/be/";
    //return "https://navis.beautecloud.com/be/";
    //return "https://sumiskin.beautecloud.com/be/";
    //return "https://esthetic.beautecloud.com/be/";
    //return "https://ebeauty.beautecloud.com/be/";
    //return "https://embrace.beautecloud.com/be/";
    //return "https://emmabelle.beautecloud.com/be/";
    //return "https://impression.beautecloud.com/be/";
    //return "https://ch.beautecloud.com/be/";
    //return "https://mydemo.beautecloud.com/be/";
    //return "https://avante.beautecloud.com/be/";
    //return "https://river.beautecloud.com/be/";
    //return "https://mb.beautecloud.com/be/";
    //return "https://elva.beautecloud.com/be/";
    //return "https://synthesis.beautecloud.com/be/";
    //return "https://ksparlour.beautecloud.com/be/";
    //return "https://pureskin.beautecloud.com/be/";
    //return "https://skinhugs.beautecloud.com/be/";
    //return "https://magicion.beautecloud.com/be/";
    //return "https://demo.beautecloud.com/be/";
    //return "https://quantum.beautecloud.com/be/";
    //return "https://energytherapy.beautecloud.com/be/";
    //return "https://jy.beautecloud.com/be/";
    //return "https://ingenious.beautecloud.com/be/";
    //return "https://koiskin.beautecloud.com/be/";
    //return "https://skinsoul.beautecloud.com/be/";
    //return "https://tnc.beautecloud.com/be/";
    //return "https://urbanspa.beautecloud.com/be/";
    //return "https://citibella.beautecloud.com/be/";
    //return "https://marmaclinic.beautecloud.com/be/";
    //return "https://appleskin.beautecloud.com/be/";
    //return "https://midyson.beautecloud.com/be/";
    //return "https://twoherbs.beautecloud.com/be/";
    //return "https://sensuous.beautecloud.com/be/";
    //return "https://test.beautecloud.com/be/";
    //return "https://beauty21.beautecloud.com/be/";
    //return "https://glamour.beautecloud.com/be/";
    //return "https://browrev.beautecloud.com/be/";
    //return "https://oursolution.beautecloud.com/be/";
    //return "https://healspa.beautecloud.com/be/";
    //return "https://beskin.beautecloud.com/be/";
  },
  getTCMUrl() {
    //return "https://crm.soha.edu.sg/apienergytcmtrain/";
    //return "https://crm.soha.edu.sg/apienergytcmlive/";
    //return "https://crm.soha.edu.sg/apihstcmv10112021/";
    return handleUrl("tcm_url");
    //return "https://crm.soha.edu.sg/apihstcmlive/";
    //return "http://crm.soha.edu.sg/apihstcm/";
    //return "https://crm.soha.edu.sg/apihstcm/";
  },
  getMediaUrl() {
    //return "http://103.253.15.184:8109/"; //skinsoul train/migrate
    //return "http://103.253.15.184:8115/"; //hstcmtrain on healspatrain db
    //return "http://103.253.15.229:8126/"; //magicionv2 in 229
    //return "http://103.253.15.184:8000/";
    //return "http://103.253.14.219:8100/"; //mydemotrain
    //return "http://103.253.15.184:8003/"; //ashiq
    //return "http://103.253.14.235:8403/"; //emmabelletest
    //return "http://103.253.15.184:8001/"; //sitedebug
    //return "http://103.253.14.235:8100/"; //stagingtrain
    //return "http://103.253.14.219:3101/"; //coulisseheirtrain
    //return "http://103.253.15.184:8101/"; //glamourtrain
    return handleUrl("media_url"); //salononetrain
    //return "http://103.253.14.235:8409/"; //ottrain
    //return "http://103.253.14.235:8406/"; //esthetictrain
    //return "http://103.253.14.235:8402/"; //essentials_train
    //return "http://103.253.14.219:8107/"; //johairtrain
    //return "http://103.253.15.229:8102/be/"; //skinsoultest
    //return "http://103.253.14.219:3107/"; //sincereskintrain
    //return "http://103.253.14.219:8101/"; //eternalbeautiquetrain
    //return "http://103.253.14.219:8110/"; //impressiontrain elenalovetrain
    //return "http://103.253.14.219:3116/"; //nailqueentrain
    //return "http://103.253.14.219:8119/"; //xinhuatcmtrain
    //return "http://103.253.14.219:8118/"; //citibellatrain
    //return "http://103.253.14.219:8116/"; //sumiskintrain
    //return "http://103.253.14.219:8102/"; //avantetrain
    //return "http://103.253.15.184:8006/"; //elvatrain
    //return "http://103.253.15.184:8120/"; //twoherbstrain
    //return "http://103.253.15.184:8102/"; //navistrain
    //return "http://103.253.15.184:8100/"; //mumandbabiestrain
    //return "http://103.253.15.184:8104/"; //synthesistrain
    //return "http://103.253.15.184:8113/"; //embracetrain
    //return "http://103.253.15.184:8112/"; //avantetrain
    //return "http://103.253.15.184:8008/"; //destresstrain
    //return "http://103.253.15.184:8002/"; //skinhugtrain monicatestwithhealspa
    //return "http://103.253.15.184:8103/"; //pureskinmigrate
    //return "http://103.253.15.184:8106/"; //pixietrain
    //return "http://103.253.15.184:8110/"; //tnctrain
    //return "http://103.253.15.184:8100/"; //mmpptrain
    //return "http://103.253.15.184:8005/"; //magiciontrain
    //return "http://103.253.15.218:8001/";
    //return "http://103.253.15.184:8000/";
    //return "http://103.253.15.184:8104/"; //Pureskintrain
    //return "http://103.253.15.184:8010/"; //KSParlour
    //return "http://103.253.15.184:8107/"; //IMDA
    //return "http://103.253.15.184:8006/"; //ksprlourtrain
    //return "http://103.253.15.184:8003/"; //citibellatrain
    //return "http://103.253.15.184:8000/"; //doodle Monica
    //return "http://103.253.15.184:8105/"; //energytcmtrain
    //return "http://103.253.15.184:8102/"; //quantum
    //return "http://103.253.15.184:8009/"; //energytrain
    //return "http://103.253.15.184:8105/"; //tnctrain
    //return "http://103.253.15.229:8101/";
    //return "https://stresstest.beautecloud.com/";
    //return "https://studioa.beautecloud.com/";
    //return "https://aplusbeauty.beautecloud.com/";
    //return "https://oceanleaf.beautecloud.com/";
    //return "https://salonone.beautecloud.com/";
    //return "https://beautesoft.nature360global.com/";
    //return "https://tnctrain.beautecloud.com/";
    //return "https://lnd.beautecloud.com/";
    //return "https://risespa.beautecloud.com/";
    //return "https://beautyforever.beautecloud.com/";
    //return "https://luxelle.beautecloud.com/";
    //return "https://beautytouch.beautecloud.com/";
    //return "https://beautypalace.beautecloud.com/";
    //return "https://vainessentials.beautecloud.com/";
    //return "https://f21.beautecloud.com/";
    //return "https://train.beautecloud.com/"; //impressiontrain
    //return "https://ot.beautecloud.com/";
    //return "https://essentials.beautecloud.com/";
    //return "https://sincereskin.beautecloud.com/";
    //return "https://johair.beautecloud.com/";
    //return "https://kirei.beautecloud.com/";
    //return "https://slbeauty.beautecloud.com/";
    //return "https://staging.beautecloud.com/";
    //return "https://nailqueen.beautecloud.com/";
    //return "https://eternalbeautique.beautecloud.com/";
    //return "https://lovebeauty.beautecloud.com/";
    //return "https://bestbeauty.beautecloud.com/";
    //return "https://xinhuatcm.beautecloud.com/";
    //return "https://navis.beautecloud.com/";
    //return "https://sumiskin.beautecloud.com/";
    //return "https://ch.beautecloud.com/";
    //return "https://esthetic.beautecloud.com/";
    //return "https://ebeauty.beautecloud.com/";
    //return "https://embrace.beautecloud.com/";
    //return "https://emmabelle.beautecloud.com/";
    //return "https://impression.beautecloud.com/";
    //return "https://mydemo.beautecloud.com/";
    //return "https://avante.beautecloud.com/";
    //return "https://river.beautecloud.com/";
    //return "https://mb.beautecloud.com/";
    //return "https://elva.beautecloud.com/";
    //return "https://synthesis.beautecloud.com/";
    //return "https://ksparlour.beautecloud.com/";
    //return "https://pureskin.beautecloud.com/";
    //return "https://skinhugs.beautecloud.com/";
    //return "https://magicion.beautecloud.com/";
    //return "https://demo.beautecloud.com/";
    //return "https://quantum.beautecloud.com/";
    //return "https://energytherapy.beautecloud.com/";
    //return "https://jy.beautecloud.com/";
    //return "https://ingenious.beautecloud.com/";
    //return "https://koiskin.beautecloud.com/";
    //return "https://skinsoul.beautecloud.com/";
    //return "https://tnc.beautecloud.com/";
    //return "https://urbanspa.beautecloud.com/";
    //return "https://citibella.beautecloud.com/";
    //return "https://marmaclinic.beautecloud.com/";
    //return "https://appleskin.beautecloud.com/";
    //return "https://midyson.beautecloud.com/";
    //return "https://twoherbs.beautecloud.com/";
    //return "https://sensuous.beautecloud.com/";
    //return "https://test.beautecloud.com/";
    //return "https://beauty21.beautecloud.com/";
    //return "https://healspa.beautecloud.com/";
    //return "https://glamour.beautecloud.com/";
    //return "https://browrev.beautecloud.com/";
    //return "https://oursolution.beautecloud.com/";
    //return "https://beskin.beautecloud.com/";
  },
  getBEUr() {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    //return "https://kirei.beautecloud.com/lb/"; //change each
    //return "https://johair.beautecloud.com/lb/"; //johair
    //return "https://jy.beautecloud.com/lb/"; //jybeauty
    //return "http://103.253.14.235:8403/"; //emmabelletest
    // return "http://sequoiasg.ddns.net:4055/lb/"; //salononetrain
    return handleUrl("backend_url"); //staging
    //return "http://103.253.14.219:3101/";
    //return "http://103.253.14.235:3419/";
    //return "http://103.253.15.184:3002/";
    //return "https://skinsoul.beautecloud.com/lb/";
    //return "http://103.253.15.184:3106/"; //pixietrain
  },
  getBELinkURL() {
    //http://103.253.14.203:4036/WebBE
    //return "http://103.253.14.203:4040/WebBe/login.aspx?"; //studioa
    //return "http://103.253.14.203:4039/WebBe/login.aspx?"; //aplus
    //return "http://103.253.14.203:4038/WebBe/login.aspx?"; //oceanleaf
    return handleUrl("web_backend_url"); //salononetrain
    //return "http://103.253.14.203:4035/WebBe/login.aspx?"; //emmabelletest
    //return "http://103.253.14.203:4034/WebBe/login.aspx?"; //salonone
    //return "http://103.253.14.203:4033/WebBe/login.aspx?"; //lnd
    //return "http://103.253.14.203:4032/WebBe/login.aspx?"; //risespa
    //return "http://103.253.15.109:9670/WebBe/login.aspx?"; //beautyforever
    //return "http://103.253.14.203:4030/WebBe/login.aspx?"; //luxelle
    //return "http://103.253.14.203:4036/WebBe/login.aspx?"; //beautytouch
    //return "http://103.253.15.109:9669/WebBe/login.aspx?"; //beautytouch old wrong
    //return "http://103.253.15.109:9668/WebBe/login.aspx?"; //beautypalace
    //return "http://103.253.15.109:9667/WebBe/login.aspx?"; //vainessentials
    //return "http://103.253.15.102:9693/WebBe/login.aspx?"; //f21
    //return "http://103.253.15.102:9692/WebBe/login.aspx?"; //staging
    //return "http://103.253.15.102:9691/WebBe/login.aspx?"; //ot
    //return "http://103.253.15.102:1691/WebBe/login.aspx?"; //ottrain
    //return "http://103.253.15.102:9599/WebBe/login.aspx?"; //essentials
    //return "http://103.253.15.102:9598/WebBe/login.aspx?"; //sincereskin
    //return "http://103.253.15.102:95988/WebBe/login.aspx?"; //sincereskintrain
    //return "http://103.253.15.102:9597/WebBe/login.aspx?"; //johair
    //return "http://103.253.15.102:9596/WebBe/login.aspx?"; //kirei
    //return "http://103.253.15.102:9595/WebBe/login.aspx?"; //slbeauty
    //return "http://sequoiasg.ddns.net:7017/WebBe/login.aspx?"; //appleskin
    //return "http://103.253.14.203:4007/WebBe/login.aspx?"; //mumandbabies
    //return "http://103.253.15.102:9594/WebBe/login.aspx?"; //esthetic
    //return "http://103.253.15.102:9593/WebBe/login.aspx?"; //ebeauty
    //return "http://103.253.14.203:4015/WebBe/login.aspx?"; //embrace
    //return "http://103.253.15.102:9592/WebBe/login.aspx?"; //emmabelle
    //return "http://103.253.15.102:9591/WebBe/login.aspx?"; //impression
    //return "http://103.253.15.102:9591/Webbe_train/login.aspx?"; //impressiontrain
    //return "http://sequoiasg.ddns.net:7041/Webbe_Train/login.aspx?"; //esthetictrain
    //return "http://sequoiasg.ddns.net:7040/Webbe_Train/login.aspx?"; //essentialtrain
    //return "http://103.253.14.203:4012/WebBe/login.aspx?"; //nailqueen
    //return "http://103.253.14.203:4012/WebBe_train/login.aspx?"; //nailqueentrain
    //return "http://103.253.14.203:4015/Webbe/login.aspx?"; //embracetrain
    //return "http://103.253.14.203:4021/Webbe/login.aspx?"; //jybeauty
    //return "http://sequoiasg.ddns.net:7039/Webbe_Train/login.aspx?"; //johairtrain
    //return "http://sequoiasg.ddns.net:7038/Webbe_Train/login.aspx?"; //sincereskintrain
    //return "http://103.253.14.203:4018/Webbe/login.aspx?"; //lovebeauty
    //return "http://sequoiasg.ddns.net:7037/Webbe_Train/login.aspx?"; //eternalbeautiquetrain
    //return "http://sequoiasg.ddns.net:7036/Webbe_Train/login.aspx?"; //elenalovetrain
    //return "http://103.253.14.203:4016/WebBE/login.aspx?"; //bestbeauty
    //return "http://103.253.14.203:4004/WebBE/login.aspx?"; //elva
    //return "http://sequoiasg.ddns.net:7008/WebBE/login.aspx?"; //skinhugs
    //return "http://103.253.14.203:4020/WebBE/login.aspx?"; //eternalbeautique
    //return "http://103.253.14.203:4019/WebBE/login.aspx?"; //navis
    //return "http://103.253.14.203:4014/WebBE/login.aspx?"; //sumiskin
    //return "http://sequoiasg.ddns.net:7016/WebBE/login.aspx?"; //magicion
    //return "http://103.253.14.203:4029/WebBE/login.aspx?"; //mydemo
    //return "http://103.253.14.203:4029/WebBE/login.aspx?"; //tnctrain
    //return "http://103.253.14.203:4012/WebBe_train/login.aspx?"; //nailqueen
    //return "http://103.253.14.203:4008/Webbe/login.aspx?"; //river
    //return "http://103.253.15.102:9499/WebBE_Train/Login.aspx?"; //chtrain
    //return "http://103.253.15.102:9499/WebBE/Login.aspx?"; //ch
    //return "http://103.253.14.203:4009/Webbe/login.aspx?"; //xinhuatcm
    //return "http://sequoiasg.ddns.net:7035/Webbe_Train/login.aspx?"; //xinhuatcmtrain
    //return "http://103.253.14.203:4011/Webbe/login.aspx?"; //citibella
    //return "http://103.253.14.203:4011/Webbe_train/login.aspx?"; //citibellatrain
    //return "http://sequoiasg.ddns.net:7023/WebBE_Train/login.aspx?"; //mumandbabiestrain
    //return "http://sequoiasg.ddns.net:7021/WebBE_Train/login.aspx?"; //navistrain
    //return "http://sequoiasg.ddns.net:7019/WebBE_train/login.aspx?"; //avantetrain
    //return "http://103.253.14.203:4013/WebBE/login.aspx?"; //avante
    //return "http://sequoiasg.ddns.net:7026/WebBE/login.aspx?"; //glamourtrain
    //return "http://sequoiasg.ddns.net:7023/WebBE/login.aspx?"; //synthesistrain
    //return "http://103.253.14.203:4005/WebBE/login.aspx?"; //synthesis
    //return "http://103.253.14.203:4002/WebBE/login.aspx?"; //skinsoul
    //return "http://103.253.14.203:4026/WebBE/login.aspx?"; //glamour
  },
  getinventorylinkurl() {
    //return "http://103.253.14.203:4040/WebInventory/login.aspx?"; //studioa
    //return "http://103.253.14.203:4039/WebInventory/login.aspx?"; //aplus
    //return "http://103.253.14.203:4038/Webinventory/login.aspx?"; //oceanleaf
    return handleUrl("web_inventory_url"); //salononetrain
    //return "http://103.253.14.203:4035/WebInventory/login.aspx?"; //emmabelletest
    //return "http://103.253.14.203:4034/WebInventory/login.aspx?"; //salonone
    //return "http://103.253.14.203:4033/WebInventory/login.aspx?"; //lnd
    //return "http://103.253.14.203:4032/WebInventory/login.aspx?"; //risespa
    //return "http://103.253.15.109:9670/WebInventory/login.aspx?"; //beautyforever
    //return "http://103.253.14.203:4030/WebInventory/login.aspx?"; //luxelle
    //return "http://103.253.14.203:4036/WebInventory/login.aspx?"; //beautytouch
    //return "http://103.253.15.109:9669/WebInventory/login.aspx?"; //beautytouch old wrong
    //return "http://103.253.15.109:9668/WebInventory/login.aspx?"; //beautypalace
    //return "http://103.253.15.109:9667/WebInventory/login.aspx?"; //vainessentials
    //return "http://103.253.15.102:9693/WebInventory/login.aspx?"; //f21
    //return "http://103.253.15.102:9692/WebInventory/login.aspx?"; //staging
    //return "http://103.253.15.102:9691/Webinventory/login.aspx?"; //ot
    //return "http://103.253.15.102:1691/Webinventory/login.aspx?"; //ottrain
    //return "http://103.253.15.102:9599/Webinventory/login.aspx?"; //essentials
    //return "http://103.253.15.102:9598/Webinventory/login.aspx?"; //sincereskin
    //return "http://103.253.15.102:95988/Webinventory/login.aspx?"; //sincereskintrain
    //return "http://103.253.15.102:9597/Webinventory/login.aspx?"; //johair
    //return "http://103.253.15.102:9596/Webinventory/login.aspx?"; //kirei
    //return "http://103.253.15.102:9595/Webinventory/login.aspx?"; //slbeauty
    //return "http://sequoiasg.ddns.net:7017/Webinventory/login.aspx?"; //appleskin
    //return "http://103.253.14.203:4007/Webinventory/login.aspx?"; //mumandbabies
    //return "http://103.253.15.102:9594/Webinventory/login.aspx?"; //esthetic
    //return "http://103.253.15.102:9593/Webinventory/login.aspx?"; //ebeauty
    //return "http://103.253.14.203:4015/Webinventory/login.aspx?"; //embrace
    //return "http://103.253.15.102:9592/Webinventory/login.aspx?"; //emmabelle
    //return "http://103.253.15.102:9591/Webinventory/login.aspx?"; //impression
    //return "http://103.253.15.102:9591/Webinventory_train/login.aspx?"; //impressiontrain
    //return "http://sequoiasg.ddns.net:7041/Webinventory_Train/login.aspx?"; //esthetictrain
    //return "http://sequoiasg.ddns.net:7040/Webinventory_Train/login.aspx?"; //essentialtrain
    //return "http://103.253.14.203:4012/Webinventory/login.aspx?"; //nailqueen
    //return "http://103.253.14.203:4012/Webinventory_train/login.aspx?"; //nailqueentrain
    //return "http://103.253.14.203:4015/Webinventory/login.aspx?"; //embracetrain
    //return "http://103.253.14.203:4021/Webinventory/login.aspx?"; //jybeauty
    //return "http://sequoiasg.ddns.net:7039/Webinventory_Train/login.aspx?"; //johairtrain
    //return "http://sequoiasg.ddns.net:7038/Webinventory_Train/login.aspx?"; //sincereskintrain
    //return "http://103.253.14.203:4018/Webinventory/login.aspx?"; //lovebeauty
    //return "http://sequoiasg.ddns.net:7037/WebInventory_Train/login.aspx?"; //eternalbeautiquetrain
    //return "http://sequoiasg.ddns.net:7036/WebInventory_Train/login.aspx?"; //elenalovetrain
    //return "http://103.253.14.203:4016/WebInventory/login.aspx?"; //bestbeauty
    //return "http://103.253.14.203:4004/WebInventory/login.aspx?"; //elva
    //return "http://sequoiasg.ddns.net:7008/WebInventoy/login.aspx?"; //skinhugs
    //return "http://103.253.14.203:4020/WebInventory/login.aspx?"; //eternalbeautique
    //return "http://103.253.14.203:4019/WebInventory/login.aspx?"; //navis
    //return "http://103.253.14.203:4014/WebInventory/login.aspx?"; //sumiskin
    //return "http://sequoiasg.ddns.net:7016/WebInventory/login.aspx?"; //magicion
    //return "http://103.253.14.203:4029/WebInventory/login.aspx?"; //mydemo
    //return "http://103.253.14.203:4029/WebInventory/login.aspx?"; //tnctrain
    //return "http://103.253.14.203:4012/WebInventory_train/login.aspx?"; //nailqueen
    //return "http://103.253.14.203:4008/WebInventory/login.aspx?"; //river
    //return "http://103.253.15.102:9499/WebInventory_Train/Login.aspx?"; //chtrain
    //return "http://103.253.15.102:9499/WebInventory/Login.aspx?"; //ch
    //return "http://103.253.14.203:4009/WebInventory/login.aspx?"; //xinhuatcm
    //return "http://sequoiasg.ddns.net:7035/WebInventory_Train/login.aspx?"; //xinhuatcmtrain
    //return "http://103.253.14.203:4011/WebInventory/login.aspx?"; //citibella
    //return "http://103.253.14.203:4011/WebInventory_train/login.aspx?"; //citibellatrain
    //return "http://sequoiasg.ddns.net:7023/WebInventory_Train/login.aspx?"; //mumandbabiestrain
    //return "http://sequoiasg.ddns.net:7021/WebInventory_Train/login.aspx?"; //navistrain
    //return "http://sequoiasg.ddns.net:7019/WebInventory_Train/login.aspx?"; //avantetrain
    //return "http://103.253.14.203:4013/WebInventory/login.aspx?"; //avante
    //return "http://sequoiasg.ddns.net:7026/WebInventory/login.aspx?"; //glamourtrain
    //return "http://sequoiasg.ddns.net:7023/WebInventory_train/login.aspx?"; //synthesistrain
    //return "http://103.253.14.203:4005/WebInventory/login.aspx?"; //synthesis
    //return "http://103.253.14.203:4002/WebInventory/login.aspx?"; //skinsoul
    //return "http://103.253.14.203:4026/WebInventory/login.aspx?"; //glamour
  },
  getreportlinkurl() {
    //return "http://103.253.14.203:4040/Webreport/login.aspx?"; //studioa
    //return "http://103.253.14.203:4039/Webreport/login.aspx?"; //aplus
    //return "http://103.253.14.203:4038/Webreport/login.aspx?"; //oceanleaf
    return handleUrl("web_report_url"); //salononetrain
    //return "http://103.253.14.203:4035/Webreport/login.aspx?"; //emmabelletest
    //return "http://103.253.14.203:4034/Webreport/login.aspx?"; //salonone
    //return "http://103.253.14.203:4033/Webreport/login.aspx?"; //lnd
    //return "http://103.253.14.203:4032/Webreport/login.aspx?"; //risespa
    //return "http://103.253.15.109:9670/Webreport/login.aspx?"; //beautyforever
    //return "http://103.253.14.203:4030/Webreport/login.aspx?"; //luxelle
    //return "http://103.253.14.203:4036/Webreport/login.aspx?"; //beautytouch
    //return "http://103.253.15.109:9669/Webreport/login.aspx?"; //beautytouch old wrong
    //return "http://103.253.15.109:9668/Webreport/login.aspx?"; //beautypalace
    //return "http://103.253.15.109:9667/Webreport/login.aspx?"; //vainessentials
    //return "http://103.253.15.102:9693/Webreport/login.aspx?"; //f21
    //return "http://103.253.15.102:9692/Webreport/login.aspx?"; //staging
    //return "http://103.253.15.102:9691/Webreport/login.aspx?"; //ot
    //return "http://103.253.15.102:1691/Webreport/login.aspx?"; //ottrain
    //return "http://103.253.15.102:9599/Webreport/login.aspx?"; //essentials
    //return "http://103.253.15.102:9598/Webreport/login.aspx?"; //sincereskin
    //return "http://103.253.15.102:95988/Webreport/login.aspx?"; //sincereskintrain
    //return "http://103.253.15.102:9597/Webreport/login.aspx?"; //johair
    //return "http://103.253.15.102:9596/Webreport/login.aspx?"; //kirei
    //return "http://103.253.15.102:9595/Webreport/login.aspx?"; //slbeauty
    //return "http://sequoiasg.ddns.net:7017/Webreport/login.aspx?"; //appleskin
    //return "http://103.253.14.203:4007/Webreport/login.aspx?"; //mumandbabies
    //return "http://103.253.15.102:9594/Webreport/login.aspx?"; //esthetic
    //return "http://103.253.15.102:9593/Webreport/login.aspx?"; //ebeauty
    //return "http://103.253.14.203:4015/Webreport/login.aspx?"; //embrace
    //return "http://103.253.15.102:9592/Webreport/login.aspx?"; //emmabelle
    //return "http://103.253.15.102:9591/Webreport/login.aspx?"; //impression
    //return "http://103.253.15.102:9591/Webreport_train/login.aspx?"; //impressiontrain
    //return "http://sequoiasg.ddns.net:7041/Webreport_Train/login.aspx?"; //esthetictrain
    //return "http://sequoiasg.ddns.net:7040/Webreport_Train/login.aspx?"; //essentialtrain
    //return "http://103.253.14.203:4012/Webreport/login.aspx?"; //nailqueen
    //return "http://103.253.14.203:4012/Webreport_train/login.aspx?"; //nailqueentrain
    //return "http://103.253.14.203:4015/Webreport/login.aspx?"; //embracetrain
    //return "http://103.253.14.203:4021/Webreport/login.aspx?"; //jybeauty
    //return "http://sequoiasg.ddns.net:7039/Webreport_Train/login.aspx?"; //johairtrain
    //return "http://sequoiasg.ddns.net:7038/Webreport_Train/login.aspx?"; //sincereskintrain
    //return "http://103.253.14.203:4018/Webreport/login.aspx?"; //lovebeauty
    //return "http://sequoiasg.ddns.net:7037/WebReport_Train/login.aspx?"; //eternalbeautiquetrain
    //return "http://sequoiasg.ddns.net:7036/WebReport_Train/login.aspx?"; //elenalovetrain
    //return "http://103.253.14.203:4016/WebReport/login.aspx?"; //bestbeauty
    //return "http://103.253.14.203:4004/WebReport/login.aspx?"; //elva
    //return "http://sequoiasg.ddns.net:7008/WebReport/login.aspx?"; //skinhugs
    //return "http://103.253.14.203:4020/WebReport/login.aspx?"; //eternalbeautique
    //return "http://103.253.14.203:4019/WebReport/login.aspx?"; //navis
    //return "http://103.253.14.203:4014/WebReport/login.aspx?"; //sumiskin
    //return "http://sequoiasg.ddns.net:7016/WebReport/login.aspx?"; //magicion
    //return "http://103.253.14.203:4029/WebReport/login.aspx?"; //mydemo
    //return "http://103.253.14.203:4029/WebReport/login.aspx?"; //tnctrain
    //return "http://103.253.14.203:4012/WebReport/login.aspx?"; //nailqueen
    //return "http://103.253.14.203:4008/WebReport/login.aspx?"; //river
    ///return "http://103.253.15.102:9499/WebReport_Train/Login.aspx?"; //chtrain
    //return "http://103.253.15.102:9499/WebReport/Login.aspx?"; //ch
    //return "http://103.253.14.203:4009/WebReport/login.aspx?"; //xinhuatcm
    //return "http://sequoiasg.ddns.net:7035/WebReport_Train/login.aspx?"; //xinhuatcmtrain
    //return "http://103.253.14.203:4011/WebReport/login.aspx?"; //citibella
    //return "http://103.253.14.203:4011/WebReport_train/login.aspx?"; //citibellatrain
    //return "http://sequoiasg.ddns.net:7023/WebReport_Train/login.aspx?"; //mumandbabiestrain
    //return "http://sequoiasg.ddns.net:7021/WebReport_Train/login.aspx?"; //navistrain
    //return "http://sequoiasg.ddns.net:7019/WebReport_Train/login.aspx?"; //avantetrain
    //return "http://103.253.14.203:4013/WebReport/login.aspx?"; //avante
    //return "http://sequoiasg.ddns.net:7026/WebReport/login.aspx?"; //glamourtrain
    //return "http://sequoiasg.ddns.net:7023/WebReport_Train/Login.aspx/login.aspx?"; //synthesistrain
    //return "http://103.253.14.203:4005/WebReport/login.aspx?"; //synthesis
    //return "http://103.253.14.203:4002/WebReport/login.aspx?"; //skinsoul
    //return "http://103.253.14.203:4026/WebReport/login.aspx?"; //glamour
  },
  getreactreportlinkurl() {  
    return handleUrl("react_report_url");
  },
  //http://sequoiasg.ddns.net:7023/WebReport_Train/Login.aspx/login.aspx?username=kk&&token=016457091c648456b4846f5f107d7af8635913a8

  helper2: function (param1) {},
  helper3: function (param1, param2) {},
};

export default helpers;
/*
const helpers = {
  getUrl() {
    return "http://103.253.15.184:8107/";
  },
  getTCMUrl() {
    return "http://crm.soha.edu.sg/apihstcm/";
  },
  getBEUr() {
    return "http://103.253.15.184:3002/";
  },

  helper2: function (param1) {},
  helper3: function (param1, param2) {},
};

export default helpers;
*/

export const debounce =
  (func, setLoading, timeout = 100) =>
  (...args) => {
    clearTimeout(timer);
    timer = setTimeout(async () => {
      typeof setLoading === "function" && setLoading(true);
      await func(...args);
      typeof setLoading === "function" && setLoading(false);
    }, [timeout]);
  };
